import { render, staticRenderFns } from "./icon-pptx.vue?vue&type=template&id=678ad1ef&"
import script from "./icon-pptx.vue?vue&type=script&lang=js&"
export * from "./icon-pptx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports